// SOMA ZapDesk brand palette (from logo)
// orange #C07A1B / deep #9A5F13 / ink #232327 / lime #9DBE3C
const palette = {
  light: {
    primary: {
      main: "#C07A1B",
      dark: "#9A5F13",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#6D6A63",
      dark: "#4E4B45",
    },
    success: { main: "#6F9427" },
    error: { main: "#D32F2F" },
    text: { secondary: "rgba(35, 35, 39, 0.6)" },
    background: {
      default: "#F1F2F4",
      paper: "#FFFFFF",
      chat: "#ECE9E2",
    },
    action: { selected: "rgba(192, 122, 27, 0.12)" },
    cards: { background: "#FFF" },
    appBar: { background: "#1B1B1F" },
    scrollbar: { thumb: "rgba(154, 95, 19, .25)" },
    userMessage: { main: "#EDE3D2" },
    contactMessage: { main: "#FFFFFF" },
    timestamp: { background: "#E4DED2" },
    queue: { fallback: "#8A7B5C" },
  },
  dark: {
    primary: {
      main: "#FFFFFF",
      dark: "#E0E0E0",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    secondary: {
      main: "#BDBDBD",
      dark: "#9E9E9E",
    },
    success: { main: "#9DBE3C" },
    error: { main: "#F44336" },
    background: {
      default: "#222226",
      paper: "#1D1D21",
      chat: "#141416",
    },
    action: { selected: "rgba(192, 122, 27, 0.18)" },
    cards: { background: "#2A2723" },
    appBar: { background: "#1B1B1F" },
    scrollbar: { thumb: "rgba(192, 122, 27, .35)" },
    userMessage: { main: "#3A332A" },
    contactMessage: { main: "#2A2723" },
    timestamp: { background: "#222226" },
    queue: { fallback: "#8A7B5C" },
  },
};

export default palette;
